module.exports = __webpack_public_path__ + "acdc36dbbe5e521d63aa01eb0c9ab077.png";